module.exports = __webpack_public_path__ + "img/money.b025e2af.svg";